import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import { createHead } from "@vueuse/head";
import "element-plus/dist/index.css";
import "./styles/main.scss";
import i18n from "./i18n";

const app = createApp(App);
const head = createHead();

app.use(head);
app.use(store);
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.mount("#app");
